module.exports = __webpack_public_path__ + "img/sentencedoctor.499c9b44.png";